import React, { useState, useEffect } from 'react';
import { getCampaignHistory } from '../../services/kollectaApi';
import Pagination from '../../Components/Pagination';
import HeaderInternal from '../../Components/HeaderInternal';
import { formatDateOnly } from '../../utils/formatDate';
import { formatNumber, formatPercent } from '../../utils/formatNumber';
import { parseCurrency } from '../../utils/currency';
import styles from './style.module.css';

const CampaignHistory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [user, setUser] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 8,
    totalItems: 0,
  });

  const fetchData = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const endDate = new Date();
      endDate.setUTCHours(23, 59, 59, 999);
      
      const startDate = new Date();
      startDate.setUTCDate(startDate.getUTCDate() - 30);
      startDate.setUTCHours(0, 0, 0, 0);

      console.log('Buscando histórico de campanhas:', { page, startDate: startDate.toISOString(), endDate: endDate.toISOString() });
      
      const response = await getCampaignHistory(
        page,
        pagination.pageSize,
        startDate.toISOString(),
        endDate.toISOString()
      );
      
      console.log('Resposta recebida:', response.data);
      
      if (response.data && response.data.data) {
        setData(response.data.data);
        setPagination(response.data.pagination || {
          page: page,
          pageSize: pagination.pageSize,
          totalItems: 0,
        });
      } else {
        console.warn('Resposta sem formato esperado:', response.data);
        setData([]);
      }
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      setError(error.response?.data?.error || error.message || 'Erro ao buscar histórico de campanhas');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userParse = JSON.parse(userData);
      setUser(userParse);
    }
  }, []);

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const getUserDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.fullName) return user.fullName;
    if (user?.firstName && user?.lastName) return `${user.firstName} ${user.lastName}`;
    return user?.email || '';
  };

  return (
    <div className={styles.container}>
      <HeaderInternal 
        title={getUserDisplayName()}
        subtitle={user?.email || ''} 
        profileImage={true}
        bold={true}
      />

      <div className={styles.content}>
        <h1 className={styles.pageTitle}>Histórico de campanhas</h1>

        {error && (
          <div className={styles.error} style={{ color: 'red', padding: '10px', margin: '10px 0' }}>
            {error}
          </div>
        )}

        {loading ? (
          <div className={styles.loading}>Carregando...</div>
        ) : (
          <>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>Data de envio</th>
                    <th>Canal</th>
                    <th className={styles.numberColumn}>Envios solicitados</th>
                    <th className={styles.numberColumn}>Envios realizados</th>
                    <th className={styles.numberColumn}>Respostas</th>
                    <th className={styles.numberColumn}>Taxa de Resposta</th>
                    <th className={styles.numberColumn}>Promessas de pagamento</th>
                    <th className={styles.numberColumn}>Acordos emitidos</th>
                    <th className={styles.numberColumn}>Acordos quitados</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="9" className={styles.noData}>
                        {error ? 'Erro ao carregar dados' : 'Nenhum dado encontrado'}
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={item.communicationRuleId || index}>
                        <td>{formatDateOnly(item.sendDate)}</td>
                        <td>
                          <span className={styles.channelBadge}>WhatsApp</span>
                        </td>
                        <td className={styles.numberColumn}>{formatNumber(item.requestedCount || 0)}</td>
                        <td className={styles.numberColumn}>{formatNumber(item.sentCount || 0)}</td>
                        <td className={styles.numberColumn}>{formatNumber(item.answeredCount || 0)}</td>
                        <td className={styles.numberColumn}>{formatPercent(item.answerRate)}</td>
                        <td className={styles.numberColumn}>
                          {parseCurrency(item.paymentPromises || 0)}
                        </td>
                        <td className={styles.numberColumn}>
                          {parseCurrency(item.agreementsIssued || 0)}
                        </td>
                        <td className={styles.numberColumn}>
                          {parseCurrency(item.agreementsSettled || 0)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            
            {pagination.totalItems > 0 && (
              <div className={styles.paginationWrapper}>
                <Pagination
                  currentPage={pagination.page}
                  setCurrentPage={handlePageChange}
                  totalItems={pagination.totalItems}
                  itemsPerPage={pagination.pageSize}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CampaignHistory;

